import { render, staticRenderFns } from "./CombinedSelectExercise.vue?vue&type=template&id=43afab27"
import script from "./CombinedSelectExercise.vue?vue&type=script&lang=js"
export * from "./CombinedSelectExercise.vue?vue&type=script&lang=js"
import style0 from "./CombinedSelectExercise.vue?vue&type=style&index=0&id=43afab27&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports